import { WorkflowParameter } from 'api/model';

export const computeParameterDefaults = (
  parameters: WorkflowParameter[],
  latestExecutionParameters?: Record<string, string>,
): Record<string, string> => {
  const result: Record<string, string> = {};
  parameters.forEach((parameter) => {
    result[parameter.name] = parameter.default_value ?? latestExecutionParameters?.[parameter.name] ?? '';
  });
  return result;
};

export const areParameterValuesValid = (parameters: WorkflowParameter[], values: Record<string, string>): boolean =>
  parameters.every((parameter) => {
    if (parameter.default_value === null) {
      return (values[parameter.name] ?? '').length > 0;
    }
    return true;
  });
